import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { IonNav } from '@ionic/angular';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { CaseService } from 'src/app/services/case.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CustomFormPage } from 'src/app/master/custom-form/custom-form.page';
import { buildNachaVariables } from 'src/app/master/custom-form/nacha-variables';

@Component({
  selector: 'app-trxservices-ach',
  templateUrl: './trxservices-ach.page.html',
  styleUrls: ['./trxservices-ach.page.scss'],
})
export class TrxservicesAchPage implements OnInit {
  @Input() caseData;
  @Input() planType = 'plan';
  @Input() selectedPlanData;
  caseId;
  @Input() debtorId = localStorage.getItem('debtor_id');
  selectedCases = [];
  debtorDetails = this.authService.debtorDetails;
  @Input() paymentMethod;
  @Input() isPaymentProposal;
  addCardForm: FormGroup;
  datemin = moment().format('YYYY-MM-DD');
  datemax = moment().add('100', 'years').format('YYYY-MM-DD');
  savedCardList = [];
  debtorDetailsSubscription: Subscription;
  caseDetailsSubscription: Subscription;
  paymentGatewayList = [];
  savedCards = [];
  isGroupArrangement = false;
  caseList = [];
  groupArrId;
  billingAddress = [];
  selectedBillingAddress;
  saveBtnDisabled = false;
  surcharge_amount = '';
  confirm_message = '';
  paymentFrequencyOption = '';

  amount; //add
  frequency; //add
  numberOfPayments = 1;
  firstPaymentDate; //date
  paymentMethods = [
    { id: 1, label: 'Cash' },
    { id: 2, label: 'Cheque' },
    { id: 4, label: 'Credit card', name: 'card' },
    { id: 5, label: 'Debit Card', name: 'bank' },
    { id: 8, label: 'BACS' },
  ];
  method = null;
  outstanding;
  firstCaseDetails;
  selectOptions = {};

  account_type_option = [
    { id: 'checking', label: this.translate.instant('ACH_PAYMENT.CHECKING') },
    { id: 'saving', label: this.translate.instant('ACH_PAYMENT.SAVING') },
  ];
  account_use_option = [
    { id: 'personal', label: this.translate.instant('ACH_PAYMENT.PERSONAL') },
    { id: 'Business', label: this.translate.instant('ACH_PAYMENT.BUSINESS') },
  ];
  fieldLabels: any = {};
  showOption:boolean = false;
  achDisclosureEnabled = false;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private caseService: CaseService,
    private authService: AuthService,
    private ionNav: IonNav,
    private alertController: AlertController,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const paymentData = this.caseService.paymentData;
    this.paymentMethod = paymentData.paymentMethod;
    this.amount = paymentData.amount;
    this.frequency = paymentData.freq;
    this.firstPaymentDate = paymentData.date;
    this.numberOfPayments = Number(paymentData.limit) || 1;
    this.outstanding = paymentData.total;
    this.caseList = paymentData.caseList;
    this.paymentFrequencyOption = paymentData.paymentFrequencyOption; //need in confirmPayment()
    //calculate service fee for show in pop up message
    const data = {
      amount: this.amount,
      type: 'ach',
    };
    this.caseService
      .calculateTrxServiceFee(this.caseId, data)
      .subscribe((res: any) => {
        this.saveBtnDisabled = false;
        if (res.data) {
          this.surcharge_amount = res.data.data.surcharge_amount.toFixed(2);
          this.confirm_message = res.data.data.confirmMessage; //variable updated
        }
      });
    if (this.planType == 'group_plan') {
      this.caseId = this.caseData[0].id;
    } else {
      this.caseId = paymentData.caseId;
    }
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (
      portalSettings.payment_method_list &&
      Object.values(portalSettings.payment_method_list)
    ) {
      this.paymentMethods = [];
      const payment_method_list = portalSettings.payment_method_list;
      Object.keys(payment_method_list).forEach((key) => {
        this.paymentMethods.push({
          id: parseInt(key),
          label: payment_method_list[key],
        });
      });
    }
    if (portalSettings?.fieldLabels) {
      this.fieldLabels = portalSettings.fieldLabels;
    }
    this.achDisclosureEnabled = !!portalSettings?.portal_details?.ach_payment_disclosure;
    this.method = this.paymentMethods[0].id
      ? this.paymentMethods[0].id.toString()
      : '';
    this.initForm();
  }

  initForm() {
    this.addCardForm = this.formBuilder.group({
      bank_routing_number: [
        '',
        // [Validators.required, Validators.pattern('^[0-9]{9,20}$')],
      ],
      bank_account_number: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),        // Only digits
          Validators.minLength(6),              // Minimum 6 digits
          Validators.maxLength(20)              // Maximum 20 digits
        ],
      ],
      account_type: ['', [Validators.required]],
      account_use: ['', [Validators.required]],
      //Add address detail in form
      address_ln1: [
        this.debtorDetails?.addresses[0]?.address_ln1
          ? this.debtorDetails.addresses[0]?.address_ln1
          : '',
        [Validators.required],
      ],
      address_town: [
        this.debtorDetails?.addresses[0]?.address_town
          ? this.debtorDetails.addresses[0]?.address_town
          : '',
        [],
      ],
      address_ln2: [
        this.debtorDetails?.addresses[0]?.address_ln2
          ? this.debtorDetails.addresses[0]?.address_ln2
          : '',
        [],
      ],
      address_ln3: [
        this.debtorDetails?.addresses[0]?.address_ln3
          ? this.debtorDetails.addresses[0]?.address_ln3
          : '',
        [],
      ],
      address_postcode: [
        this.debtorDetails?.addresses[0]?.address_postcode
          ? this.debtorDetails.addresses[0]?.address_postcode
          : '',
        [Validators.required],
      ],
      description: [''],
      //Add debtor name for form
      debtor_name: [
        this.debtorDetails?.debtor_name
          ? this.debtorDetails.debtor_name
          : '',
        [Validators.required],
      ],
      //Add debtor email for form
      debtor_email: [
        this.debtorDetails?.debtor_email
          ? this.debtorDetails.debtor_email
          : '',
        [Validators.required],
      ],
    });
  }

  async save() {
    this.addCardForm.markAllAsTouched();
    if (this.addCardForm.valid) {
      if (this.achDisclosureEnabled) {
        // Simons Agency shows the NACHA recurring disclosure form; other clients get the standard alert.
        if (this.caseService.isClient('simonsagency')) {
          const values = this.addCardForm.getRawValue();
          this.ionNav.push(CustomFormPage, {
            case_id: this.caseId,
            debtor_id: this.debtorDetails.debtor_id,
            form_slug: 'case_form_NACHA_recurring',
            dpa_check: 'dob',
            // Recurring plan: the disclosure reads the first instalment's date.
            variables: buildNachaVariables({
              accountType: values.account_type,
              routingNumber: values.bank_routing_number,
              accountNumber: values.bank_account_number,
              amount: this.amount,
              currencySymbol: this.caseService.getCurrencySymbol(),
              paymentDate: this.firstPaymentDate,
              accountName: values.debtor_name,
              // The schedule table the debtor just reviewed on this screen.
              scheduleHtml: this.selectedPlanData,
              numberOfPayments: this.numberOfPayments,
              frequency: this.frequency,
            }),
            onFormSubmitted: () => {
              this.proceedAfterDisclosure();
            },
          });
          return;
        } else {
          const disclosureAlert = await this.alertController.create({
            header: this.translate.instant('ACH_PAYMENT.DISCLOSURE_TITLE'),
            message: this.translate.instant('ACH_PAYMENT.DISCLOSURE_MESSAGE'),
            cssClass: 'ach-disclosure-alert-class',
            buttons: [
              {
                text: this.translate.instant('COMMON.CANCEL'),
                role: 'cancel',
                handler: () => {},
              },
              {
                text: this.translate.instant('COMMON.CONFIRM'),
                handler: () => {
                  this.proceedAfterDisclosure();
                },
              },
            ],
          });
          await disclosureAlert.present();
          return;
        }
      }
      this.proceedAfterDisclosure();
    }
  }

  async proceedAfterDisclosure() {
      /*@see LU-171 for showing payment confirmation pop up */
      if (this.confirm_message) {
        const alert = await this.alertController.create({
          header: 'There is a convenience fee per payment in the amount of ' + this.surcharge_amount + ' and Please confirm your agreement to this fee on each payment',
          message: `<ion-item>
                  <ion-label position="stacked">Your Name</ion-label>
                  <ion-input name="name" type="text" placeholder="Enter your name..." required></ion-input>
                </ion-item>
                <ion-item lines="none">
                  <ion-checkbox name="agreement" slot="start" value="agree"></ion-checkbox>
                  <ion-label>Agreed</ion-label>
                </ion-item>`,
          cssClass: 'custom-alert-class',
          buttons: [
            {
              text: this.translate.instant('COMMON.CANCEL'),
              role: 'cancel',
              handler: () => {},
            },
            {
              text: this.translate.instant('COMMON.OK'),
              handler: (data) => {
                const nameInput = document.querySelector(
                  'ion-input[name="name"]'
                ) as HTMLIonInputElement;
                const agreementCheckbox = document.querySelector(
                  'ion-checkbox[name="agreement"]'
                ) as HTMLIonCheckboxElement;
                const name = nameInput?.value;
                const agreement = agreementCheckbox?.checked;
                if (name && agreement) {
                  this.confirmPayment();
                } else {
                  if (!name) {
                    this.showAlert(this.translate.instant('PAYMENT.ENTER_NAME'));
                  } else if (!agreement) {
                    this.showAlert(this.translate.instant('PAYMENT.AGREE_TERMS'));
                  }
                  return false; // Prevents the alert from closing
                }
              },
            },
          ],
        });
        await alert.present();
      } else {
        this.confirmPayment();
      }
  }

//show alert if name of aggrement checkbox is not checked
  async showAlert(message: string) {
    const alert = await this.alertController.create({
      header: this.translate.instant('PAYMENT.ALERT'),
      message: message,
      buttons: ['OK'],
    });
    await alert.present();
  }

//paymet confirmation
  confirmPayment() {
    /** start date update when payment frequency option is month */
    var start = '';
    if (this.paymentFrequencyOption == 'month') {
      start = moment(this.firstPaymentDate).format('YYYY-MM-DD');
    } else{
      start = this.firstPaymentDate.split('T')[0];
    }
    this.commonService.showLoader();
    let paymentPlan = this.caseService.getPaymentData();
    let data = {
      amount: this.amount ? this.amount : this.outstanding,
      freq: this.frequency,
      start: start,
      ref_amount: this.outstanding,
      description: this.addCardForm.value.description,
      routing: this.addCardForm.value.bank_routing_number,
      account: this.addCardForm.value.bank_account_number,
      account_type: this.addCardForm.value.account_type,
      account_use: this.addCardForm.value.account_use,
      payment_method: 'trxServices',
      debtor_email: this.addCardForm.value.debtor_email,
      debtor_id: this.debtorDetails.debtor_id,
      address_ln1: this.addCardForm.value.address_ln1,
      address_ln2: this.addCardForm.value.address_ln2,
      town: this.addCardForm.value.address_town,
      address_ln3: this.addCardForm.value.address_ln3,
      address_postcode: this.addCardForm.value.address_postcode,
      debtor_name: this.addCardForm.value.debtor_name,
      is_group: this.planType == 'group_plan' ? 1 : 0,
      cases: this.caseList,
      // Add these properties always, set to undefined if not proposal
      caseid: paymentPlan['isPaymentProposal'] ? this.caseId : undefined,
      frequency: paymentPlan['isPaymentProposal'] ? this.frequency : undefined,
      isGroupArrangement: paymentPlan['isPaymentProposal'] ? (this.planType == 'group_plan' ? true : false) : undefined,
      arrangement_id:undefined, // This will be set if the arrangement is created successfully
      
    };
    this.caseService
      .newRecurringACHPaymentPlan(this.caseId, data)
      .subscribe((res: any) => {
        this.saveBtnDisabled = false;
        this.commonService.dismissLoader();
        //handle API response
        if (res.data.success) {
          this.caseService.saveCaseDetails(localStorage.getItem('debtor_id'));

          if (res.data.data.arrangement_id) {
              data = { ...data, arrangement_id: res.data.data.arrangement_id };
            }

            this.caseService.paymentPlan(data).subscribe((res: any) => {

          });
          this.ionNav.popToRoot();
          this.commonService.showToast(
            this.translate.instant('PAYMENT.ACTION_PERFORMED_SUCCESSFULLY'),
            'success'
          );
        } else {
          this.commonService.showToast(res.data.message, 'danger');
        }
      });
  }

  toggleOptions(value) {
    this.showOption = (value == false) ? true : false;
  }
}
